import api from '../api';
import { saveAs } from 'file-saver';
class ContactServices {

   async getContactList(searchModel) {
        return await api.post(`ManageSiteContact/GetContactList`, searchModel)
    }
    async deleteContact(contactId, userId, companyId, IPAddress) {
        return await api.get(`ManageSiteContact/DeleteByContactId/${contactId}/${userId}/${companyId}/${IPAddress}`)
    }
    async ExportData(records, type, filename, pageLength = "") {
        if (type == 'Excel') {
            api.post(`Common/ExportExcelInvoice/${type}/${filename}/${pageLength}`, records, { responseType: 'blob' }).then(response => {
                saveAs(response.data, filename + ".xlsx")
            })
        }
        else if (type == 'CSV') {
            api.post(`Common/ExportExcelInvoice/${type}/${filename}/${pageLength}`, records, { responseType: 'blob' }).then(response => {
                saveAs(response.data, filename + ".csv")

            })
        }
        else if (type == 'PDF'){
            api.post(`Common/ExportExcelInvoice/${type}/${filename}/${pageLength}`, records, { responseType: 'blob' }).then(response => {
                saveAs(response.data, filename + ".pdf")
            })
        }
    }
    async getArticleslist(searchFields, status, sortColumn, sortDir, pageIndex, pageSize, userid, companyId) {
        debugger;
        if (searchFields == '') { searchFields = '00Test' }
        return await api.get(`Article/GetArticlesList/${searchFields}/${status}/${sortColumn}/${sortDir}/${pageIndex}/${pageSize}/${userid}/${companyId}`);
    }
    async AddupdateArticle(article) {
        debugger;
        return await api.post(`Article/AddUpdateArticle`, article, {
            "Content-Type": "multipart/form-data"
        });
    }
    async getArticleDatabyId(id) {
        debugger;
        return await api.get(`Article/${id}`);
    }
    async deleteArticle(tablename, primaryKey, id, title, UserId, CompanyId, IPAddress) {
        return await api.get(`Article/DeleteRecord/${tablename}/${primaryKey}/${id}/${title}/${UserId}/${CompanyId}/${IPAddress}`);
    }
    async setArticleStatus(tablename, id, status, title) {
        debugger
        return await api.get(`Article/${tablename}/${id}/${status}/${title}`);
    }
    async GetBookingPropertyList(searchModel) {
        return await api.post(`ManageSiteContact/GetBookingPropertyList`, searchModel)
    }
    async GetBookingPropertyListForUser(searchModel, ShareId) {
        return await api.post(`ManageSiteContact/GetBookingPropertyListForUser`, searchModel, { params: { ShareId: ShareId } })
    }
    async deletecompanyuser(tablename, id, title, userId, companyId, ipaddress) {
        return await api.get(`CompanyUsers/DeleteCompanyUser/${tablename}/${id}/${title}/${userId}/${companyId}/${ipaddress}`);
    }
    async UpdateBookedStatus(changeStatusModel) {
        return await api.post(`ManageSiteContact/BookingStatus`, changeStatusModel)
    }
    async AssetListDropdown(CompanyId, UserId, UserType) {
        return await api.get(`Blog/GetCompanyassetDrp/${CompanyId}/${UserId}/${UserType}`)
    }
    async CancelBooking(cancelBooking) {
        return await api.post(`ManageSiteContact/CancelBooking`, cancelBooking)
    }
    async DeleteBookingById(data)
    {
        debugger;
        return await api.post(`ManageSiteContact/DeleteBookingById`, data)        
    }
}

export default new ContactServices();